import styled from 'styled-components';
import ArrowBackIcon from '@/assets/mo/ArrowBack.svg?react';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();

  return (
    <HeaderContainer>
      <LeftSection onClick={() => navigate('/allbadeum')}>
        <BackButton>
          <ArrowBackIcon />
        </BackButton>
        <TitleWrapper>후기</TitleWrapper>
      </LeftSection>

      <RightSection>
        <ButtonGroup>
          <CallButton
            onClick={() => {
              window.location.href = 'https://nicetomeetyou.oopy.io';
            }}
          >
            전화 상담
          </CallButton>
          <ApplyButton onClick={() => navigate('/appointment')}>무료 선임 신청</ApplyButton>
        </ButtonGroup>
      </RightSection>
    </HeaderContainer>
  );
};

export default Header;

// ====================== styled-components ======================

const HeaderContainer = styled.header`
  display: flex;
  padding: 4px 20px 4px 4px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  background: var(--Primary-white, #fff);
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  flex: 1 0 0;
`;

const BackButton = styled.div`
  display: flex;
  width: 48px;
  height: 48px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  cursor: pointer;
`;

const TitleWrapper = styled.div`
  display: flex;
  padding: 0px 16px;
  align-items: flex-end;
  gap: 10px;
  flex: 1 0 0;

  color: var(--gray-ui_gray02, #252525);
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.32px;
`;

const RightSection = styled.div`
  display: flex;
  height: 42px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 10px;
`;

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

const CallButton = styled.button`
  display: flex;
  height: 26px;
  padding: 8px 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  background: var(--states-red, #f42d16);
  color: var(--Primary-white, #fff);
  border: none;
  cursor: pointer;

  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  letter-spacing: -0.28px;
`;

const ApplyButton = styled.button`
  display: flex;
  height: 26px;
  padding: 8px 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  background: var(--Primary-brand_01, #0b46dd);
  color: var(--Primary-white, #fff);
  border: none;
  cursor: pointer;

  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  letter-spacing: -0.28px;
`;
